<template>
    <div class="TagList pa-3">
        <v-text-field
            outlined
            dense
            hide-details
            v-model="searchKey"
            class="mb-3"
            :label="this.$f.tc('search')"
        ></v-text-field>
        <FCIDataTable :items="filterItems" :headers="headers">
            <template v-slot:stepWithIntent="props">
                <span v-for="(step, i) in props.item.steps" :key="i" class="wrap-item">
                    {{ step.name }}
                    <template v-if="step.intent">| {{ step.intent }}</template>
                </span>
            </template>
            <template v-slot:action="props">
                <v-btn icon class="mr-3">
                    <v-icon @click="editItem(props.item, props.index)">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon>
                    <v-icon @click="deleteItem(props.item, props.index)">mdi-delete</v-icon>
                </v-btn>
            </template>
        </FCIDataTable>
        <v-btn color="primary" class="mt-3" @click="addItem">{{ $f.tc('add') }}</v-btn>
    </div>
</template>

<script>
import ListViewMixin from '@/modules/fptai/mixins/ListViewMixin'
import { TagService } from '@/services/bot.service'
import { AppEventBusType } from '@/eventbus/app.eventbus'

export default {
    name: 'TagList',
    mixins: [ListViewMixin],
    computed: {
        headers () {
            return [
                {
                    text: this.$f.tc('tag'),
                    value: 'name'
                },
                {
                    text: this.$f.tc('step') + ' | ' + this.$f.tc('intent'),
                    value: 'stepWithIntent',
                    type: 'custom'
                },
                {
                    text: this.$f.tc('action'),
                    value: 'action',
                    type: 'custom'
                }
            ]
        }
    },
    methods: {
        refresh () {
            TagService.getTagWithStepInfo(this.$route.params.botCode).then(result => {
                this.items = result.data
            })
        },
        addItem () {
            this.$appService.useEventBus(
                AppEventBusType.EDIT_TEXT,
                {
                    title: 'Tag',
                    text: ''
                }
            ).then(text => {
                TagService.create(this.$route.params.botCode, {
                    name: text
                }).then(() => {
                    this.refresh()
                })
            })
        },
        editItem (item, index) {
            this.$appService.useEventBus(
                AppEventBusType.EDIT_TEXT,
                {
                    title: 'Tag',
                    text: item.name
                }
            ).then(text => {
                if (text !== item.name) {
                    TagService.update(this.$route.params.botCode, item.code, {
                        name: text
                    }).then(result => {
                        this.items[index].name = result.data.name
                    })
                }
            })
        },
        onDeleteItem (item, index) {
            TagService.delete(this.$route.params.botCode, item.code).then(() => {
                this.items.splice(index, 1)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.wrap-item {
    background: #D0D4E2;
    border-radius: 5px;
    padding: 5px;
    margin: 0 5px 5px 0;
}
.TagList::v-deep table {
    table-layout: fixed;

    tr th {
        &:nth-child(3) {
            width: 180px;
        }
    }
}
</style>
